import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const SignInFormWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  .sign-in-head {
    text-align: center;
    margin-bottom: 24px;
    &-title {
      margin-bottom: 24px;
      color: ${({ theme }) => theme.colors.grayPallet1};
    }
    &-subtitle {
      letter-spacing: 0.8px;
      color: ${({ theme }) => theme.colors.gray};
    }
    &-err {
      background-color: rgba(255, 0, 0, 0.1);
      border: 1px solid ${({ theme }) => theme.colors.red};
      width: 80%;
      margin: 0 auto;
      margin-top: 24px;
      padding: 8px;
      color: ${({ theme }) => theme.colors.red};
    }
  }
  .sign-in-form {
    &-submit {
      > button {
        border-radius: unset;
      }
    }
    &-google {
    }
  }
  .sign-in-forgot {
    margin: 24px 0;
    display: flex;
    p {
      color: ${({ theme }) => theme.colors.green};
      opacity: 0.8;
    }
  }
  .or-line {
    margin: 24px 0;
    color: ${({ theme }) => theme.colors.grayPallet1};
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span {
      width: 25%;
      border: 1px solid ${({ theme }) => theme.colors.whitePallet1};
    }
  }
  .sign-in-google {
    > button {
      width: 100%;
      height: 58px;
      border: 1px solid rgba(43, 43, 43, 0.1) !important;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: unset !important;
      p {
        color: ${({ theme }) => theme.colors.bluePallet1};
      }
    }
  }

  @media ${device.tablet} {
    width: 100%;
  }
`;
